import { action } from 'typesafe-actions';
import { Actions, TDefRequest } from '../Action';
import ActionTypes, { TPrivateChat, TPrivateChatState, TPrivateMessage } from './types';

export const PrivateChatActions = {
  setCreatedPChat: (payload: TPrivateChat) => action(ActionTypes.SET_CREATED_PRIVATE_CHAT, payload),
  setNewPMessage: (payload: TPrivateMessage) => action(ActionTypes.SET_NEW_PRIVATE_MESSAGE, payload),
  setCurrentUserId2: (payload: string | null) => action(ActionTypes.SET_CURRENT_USER_ID2, payload),
};

const GetPrivateChatsAction = new Actions('GET_PRIVATE_CHATS', ActionTypes);
export interface TypeGetPrivateChatsR extends TDefRequest {
  data: {
    event_id: number;
    roomId: number;
  };
}
export const GetPrivateChats = {
  request: (payload: TypeGetPrivateChatsR) => GetPrivateChatsAction.request(payload),
  success: (payload: TPrivateChatState['privateChats']) => GetPrivateChatsAction.success(payload || {}),
  error: (message: string) => GetPrivateChatsAction.error(message),
};

const ClosePrivateChatAction = new Actions('CLOSE_PRIVATE_CHAT', ActionTypes);
export interface TypeClosePrivateChatR extends TDefRequest {
  data: {
    event_id: number;
    roomId: number;
    userId: string;
  };
}
export const ClosePrivateChat = {
  request: (payload: TypeClosePrivateChatR) => ClosePrivateChatAction.request(payload),
  success: (payload: TPrivateChat) => ClosePrivateChatAction.success(payload || {}),
  error: (message: string) => ClosePrivateChatAction.error(message),
};

const OpenPrivateChatAction = new Actions('OPEN_PRIVATE_CHAT', ActionTypes);
export interface TypeOpenPrivateChatR extends TDefRequest {
  data: {
    event_id: number;
    roomId: number;
    userId: string;
  };
}
export const OpenPrivateChat = {
  request: (payload: TypeOpenPrivateChatR) => OpenPrivateChatAction.request(payload),
  success: (payload: TPrivateChat) => OpenPrivateChatAction.success(payload || {}),
  error: (message: string) => OpenPrivateChatAction.error(message),
};

const SendPrivateMessageAction = new Actions('SEND_PRIVATE_MESSAGE', ActionTypes);
export interface TypeSendPrivateMessageR extends TDefRequest {
  data: {
    event_id: number;
    roomId: number;
    userId: string;
    message: string;
  };
}
export const SendPrivateMessage = {
  request: (payload: TypeSendPrivateMessageR) => SendPrivateMessageAction.request(payload),
  success: (payload: TPrivateMessage) => SendPrivateMessageAction.success(payload || {}),
  error: (message: string) => SendPrivateMessageAction.error(message),
};
